import React from "react";
import { Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

const CLOCK_SYNC_URL = "http://192.168.0.12:8072/run-sync";

const AttendanceClockSyncButton = () => (
	<Button
		icon={<ReloadOutlined />}
		href={CLOCK_SYNC_URL}
		target="_blank"
		rel="noopener noreferrer">
		출근정보 새로고침
	</Button>
);

export default AttendanceClockSyncButton;
